import { render, staticRenderFns } from "./LeadsListingTable.vue?vue&type=template&id=a197b056"
import script from "./LeadsListingTable.vue?vue&type=script&lang=js"
export * from "./LeadsListingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports